const axios = require('axios');
const rax = require('retry-axios');
const { logger } = require('@fiverr-private/obs');
const { FILTER } = require('../config/filters');
const metricsService = require('../../../shared/service/metrics');
const { HttpStatusCode } = require('../../../shared/types/httpStatusCode');
const { PROMOTED_GIGS } = require('./constants');
const { replaceAll } = require('./string');
const { USD_CURRENCY, DEFAULT_REQUEST_RETIRES, DEFAULT_REQUEST_METHOD } = require('./constants');

module.exports = {
    convertStringToConstValue(string) {
        return string.split(/(?=[A-Z])/).join('_').toUpperCase();
    },
    clearObjectValues(object) {
        return Object.keys(object).reduce((acc, filterKey) => {
            acc[filterKey] = undefined;
            return acc;
        }, {});
    },
    customToString(params) {
        return params.reduce((acc, item) => {
            acc += `${encodeURIComponent(item[0])}=${encodeURIComponent(item[1])}&`;
            return acc;
        }, '');
    },

    normalizeActiveFilter: (activeFilters, currency) => {
        const priceRangeId = FILTER.GIG_PRICE_RANGE.ID,
            priceRangeFilter = activeFilters[priceRangeId];

        if (!priceRangeFilter || currency.name === USD_CURRENCY) {
            return { ...activeFilters };
        }

        const [min, max] = priceRangeFilter;
        const convertedFilter = [_convertToUSD(min, currency.rate), max === FILTER.GIG_PRICE_RANGE.DEFAULTS.MAX ? max : _convertToUSD(max, currency.rate)];
        return {
            ...activeFilters,
            [priceRangeId]: convertedFilter
        };
    },

    axiosRetrier: async(route, options = {}, maxAttempts = DEFAULT_REQUEST_RETIRES) => {
        let retried = false;
        const serviceRoute = _getServiceFromRoute(route);
        const startTime = new Date();

        const onFailedAttempt =  (err) => {
            retried = true;
            const message = `Retriable error caught for ${route}`;
            axiosError({ route, service: serviceRoute, message, err, startTime, countSuffix: 'retry' });
        };

        const onBreach = (err) => {
            const message = `Breach error caught for ${serviceRoute}`;
            axiosError({ route, service: serviceRoute, message, err, startTime, countSuffix: 'final' });
            metricsService.time(`request_service.success.time.${serviceRoute}.breach`, startTime);
        };

        try {
            const { timeout, method = DEFAULT_REQUEST_METHOD } = options;
            const axiosInstance = axios.create();

            axiosInstance.defaults.timeout = timeout;
            axiosInstance.defaults.raxConfig = {
                instance: axiosInstance,
                retry: maxAttempts,
                httpMethodsToRetry: [method.toUpperCase()],
                statusCodesToRetry: [[
                    HttpStatusCode.REQUEST_TIMEOUT,
                    HttpStatusCode.SERVICE_UNAVAILABLE,
                    HttpStatusCode.GATEWAY_TIMEOUT
                ]],
                onRetryAttempt: onFailedAttempt
            };

            rax.attach(axiosInstance);

            const runAxios = async() => axiosInstance.request({
                url: route,
                method: method.toLowerCase()
            });

            const { data } = await runAxios();

            metricsService.time(`request_service.success.time.${serviceRoute}`, startTime);
            retried && metricsService.count('request_service.recovery.success');

            return data;
        } catch (err) {
            onBreach(err);
            throw err;
        }
    },

    getPairSelected: ({ options }) => {
        const { fromOptions, toOptions } = options;
        const [ fromValue ] = fromOptions.filter((opt) => opt.selected);
        const [ toValue ] = toOptions.filter((opt) => opt.selected);
        const pairDefaultValue = FILTER.LANGUAGES_PAIR.DEFAULT;

        return {
            fromValue: fromValue ? fromValue.id : pairDefaultValue,
            toValue: toValue ? toValue.id : pairDefaultValue
        };
    },

    replaceAll,

    splitArray: (arr, splitBy) => {
        const filtered = arr.filter(splitBy);
        return [filtered, arr.filter((item) => !splitBy(item))];
    },

    objectValues: (obj) => Object.keys(obj).map((key) => obj[key]),

    includesAds: (gigs) => !!gigs.find((gig) => gig.type === PROMOTED_GIGS)
};

const axiosError = ({ route, service, err, startTime, message, countSuffix }) => {
    const totalTime = new Date() - startTime;

    const errorContext = {
        route,
        service,
        totalTime,
        text: err.message,
        status: err.status,
        retriesLeft: err.retriesLeft,
        attempt: err.attempt
    };

    logger.warn(`[Search Perseus - Axios Retrier] ${message}`, errorContext);
    metricsService.count(`request_service.fail.${service}.${countSuffix}`);
};

const _convertToUSD = (amount, rate = 1) => (amount / (rate !== 0 ? rate : 1)).toFixed(2);
const _getServiceFromRoute = (route) => {
    const regex = /https?:\/\/[^/]*\/([^/]*)\//;
    const match = regex.exec(route);
    return match && match[1] ? match[1].replace(/-/g, '_') : 'unknown';
};
